module.exports = __webpack_public_path__ + "img/pizza-with-hand-1.b8a91081.jpg";